<template>
    <v-dialog-old ref="dialog" @hidden="reset">
        <fieldset>
            <legend>Причина отклонения</legend>
            <label><input type="radio" v-model="reason" value="Размещение контактов запрещено"><span>Размещение контактов запрещено</span></label>
            <label><input type="radio" v-model="reason" value="Ссылки запрещены, приложите файлы к ответу"><span>Ссылки запрещены, приложите файлы к ответу</span></label>
            <label><input type="radio" v-model="reason" value="Другое"><span>Другая причина</span></label>
            <textarea v-model="reasonText" :disabled="reason !== 'Другое'"></textarea>
        </fieldset>
        <footer>
            <button class="green" @click="rejectAnswer" :disabled="isBtnDisabled()">Отклонить ответ</button>
        </footer>
    </v-dialog-old>
</template>

<script>
    export default {
        props: {
            commentId: { type: [Number, String], required: true },
        },
        data: () => ({
            reason: null,
            reasonText: null,
        }),
        methods: {
            rejectAnswer() {
                if (this.isBtnDisabled()) {
                    return;
                }

                let reason = this.reason === 'Другое' ? this.reasonText : this.reason
                this.axios
                    .post('reviewComments/decline/' + this.commentId, {reason: reason})
                    .then(response => {
                        this.$emit('declined');
                        this.reset()
                        this.$refs.dialog.hide()
                    })
            },
            reset() {
                this.reason = null
                this.reasonText = null
            },
            isBtnDisabled() {
                if (!this.reason) {
                    return true;
                }

                if (this.reason === 'Другое' && !this.reasonText) {
                    return true;
                }
            }
        }
    }
</script>
